import api from '../Axios'; 

export const pushNotificationsApi = {
  subscribe: async (subscriptionData: PushSubscription) => {
    const response = await api.post('/api/push/subscribe', subscriptionData);
    return response.data;
  },

  unsubscribe: async (endpoint: string) => {
    const response = await api.post('/api/push/unsubscribe', { endpoint });
    return response.data;
  },

  testNotification: async () => {
    const response = await api.post('/api/push/test');
    return response.data;
  },

  getNotificationHistory: async () => {
    const response = await api.get('/api/push/history'); 
    return response.data;
  },
  
  markAsRead: async (id: string) => {
    const response = await api.patch(`/api/push/${id}/read`);
    return response.data;
  },

  // 🟢 NEW: Call the backend to mark all as read
  markAllAsRead: async () => {
    const response = await api.patch('/api/push/mark-all-read');
    return response.data;
  },

  notifyProfileView: async (expertCode: string, userName: string = 'A user') => {
    const response = await api.post('/api/push/send', {
      receiverId: expertCode,
      title: 'Profile Viewed! 👀',
      message: `User ${userName} is interacting with your profile right now. Stay online to connect with them!`,
      url: `/expert-dashboard` 
    });
    return response.data;
  }
};